var _line, _circle, _line2, _circle2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgFilter(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 14,
    height: 10,
    viewBox: "0 0 14 10",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _line || (_line = /*#__PURE__*/React.createElement("line", {
    x1: 1.25,
    y1: 2.25,
    x2: 8.75,
    y2: 2.25,
    stroke: "#202124",
    strokeWidth: 1.1,
    strokeLinecap: "round"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 11,
    cy: 2.5,
    r: 1.75,
    fill: "white",
    stroke: "#202124",
    strokeWidth: 1.1
  })), _line2 || (_line2 = /*#__PURE__*/React.createElement("line", {
    x1: 12.75,
    y1: 7.75,
    x2: 5.25,
    y2: 7.75,
    stroke: "#202124",
    strokeWidth: 1.1,
    strokeLinecap: "round"
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 3,
    cy: 7.5,
    r: 1.75,
    transform: "rotate(-180 3 7.5)",
    fill: "white",
    stroke: "#202124",
    strokeWidth: 1.1
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFilter);
export default __webpack_public_path__ + "static/media/Filter.a97a1b9c6a79bdee999429e23647421a.svg";
export { ForwardRef as ReactComponent };